import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderLayout } from '@backstage/plugin-scaffolder-react';
import { TwoColumn } from './twoColumnLayouts';

export const TwoColumnLayout = scaffolderPlugin.provide(
  createScaffolderLayout({
    name: 'TwoColumn',
    component: TwoColumn,
  }),
);
